import { useState, useEffect } from 'react';

function getWindowDimensions() {
  const hasWindow = typeof window !== 'undefined' && typeof document !== 'undefined';

  const width = hasWindow ? document.body.clientWidth : null;
  const height = hasWindow ? document.body.clientHeight : null;
  // const width = hasWindow ? window.innerWidth : null;
  // const height = hasWindow ? window.innerHeight : null;
  return {
    width,
    height,
  };
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}
